import {createSlice} from "@reduxjs/toolkit";

const initialSchDocumentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  schDocumentForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const schDocumentsSlice = createSlice({
  name: "schDocuments",
  initialState: initialSchDocumentsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSchDocumentById
    schDocumentFetched: (state, action) => {
      state.actionsLoading = false;
      state.schDocumentForEdit = action.payload.schDocumentForEdit;
      state.error = null;
    },
    // findSchDocuments
    schDocumentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createSchDocument
    schDocumentCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.schDocument);
    },
    // updateSchDocument
    schDocumentUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schDocumentId === action.payload.schDocument.schDocumentId) {
          return action.payload.schDocument;
        }
        return entity;
      });
    },
    // deleteSchDocument
    schDocumentDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schDocumentId !== action.payload.schDocumentId);
    },
    // deleteSchDocuments
    schDocumentsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schDocumentId)
      );
    },
  }
});
